import { httpClient, ApiResponse } from '@/utils';
import {
  staticFaqEndpoints,
  getFaqEndpoints,
  ICreateFaqDTO,
  ICreateFaqResponse,
  IDeleteFaqsDTO,
  IUpdateFaqDTO,
  IGetFaqsDTO,
  IGetFaqsResponse,
} from '@/models/faq.model';

class FaqAPI {
  static getFaqs({ channelId, ...params }: IGetFaqsDTO): ApiResponse<IGetFaqsResponse> {
    const { GET_FAQS } = staticFaqEndpoints({ channelId });
    return httpClient.get<IGetFaqsResponse>(GET_FAQS, {
      params,
    });
  }

  static createFaq({ channelId, ...data }: ICreateFaqDTO): ApiResponse<ICreateFaqResponse> {
    const { CREATE_FAQ } = staticFaqEndpoints({ channelId });
    return httpClient.post<ICreateFaqResponse>(CREATE_FAQ, data);
  }

  static updateFaq({ faqId, channelId, ...data }: IUpdateFaqDTO): ApiResponse<ICreateFaqResponse> {
    const { UPDATE_FAQ } = getFaqEndpoints({ channelId, faqId });
    return httpClient.patch<ICreateFaqResponse>(UPDATE_FAQ, data);
  }

  static deleteFaqs({ channelId, ...data }: IDeleteFaqsDTO): ApiResponse<void> {
    const { DELETE_FAQS } = staticFaqEndpoints({ channelId });
    return httpClient.delete<void>(DELETE_FAQS, { data });
  }
}

export default FaqAPI;
